import { render } from "./LiquidationHistory.vue?vue&type=template&id=69406ba0"
import script from "./LiquidationHistory.vue?vue&type=script&lang=js"
export * from "./LiquidationHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__